import React from "react";
import { TextField, IconButton, makeStyles } from "@material-ui/core";
import { Explore, RotateLeft } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import { getDateTimeString } from "../../utils";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginBottom: 5,
    fontSize: 10,
    maxWidth: 200,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    padding: "0px 10px",
  },
  submitButtons: {
    marginTop: 5,
  },
}));

export const IntervalsPickerForm = ({
  onSubmit,
  resetIcon = <RotateLeft />,
  submitIcon = <Explore />,
  onResetFilter = () => {},
  align = "column",
}) => {
  const classes = useStyles();
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const { t } = useTranslation();

  let maxEndTime = startDate !== "" ? new Date(Date.now()) : "";
  if (startDate !== "")
    maxEndTime =
      maxEndTime > new Date(Date.now()) ? new Date(Date.now()) : maxEndTime;
  const minEndDate =
    startDate !== "" ? getDateTimeString(new Date(startDate)) : "";
  const maxStartDate = getDateTimeString(new Date(Date.now())) ?? "";
  const maxEndDate = maxEndTime !== "" ? getDateTimeString(maxEndTime) : "";

  const onChange = (event) => {
    if (event.target.name === "start_time") setStartDate(event.target.value);
    else if (event.target.name === "end_time") setEndDate(event.target.value);
  };

  const reset = () => {
    onResetFilter();
    setStartDate("");
    setEndDate("");
  };

  return (
    <>
      <form className={classes.container} onSubmit={onSubmit}>
        <div
          style={{
            display: "flex",
            flexDirection: align,
            width: align === "row" ? 400 : "auto",
            justifyContent: "space-around",
          }}
        >
          <TextField
            label={t("START_DATE_TIME")}
            type="datetime-local"
            name="start_time"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={onChange}
            value={startDate}
            InputProps={{
              inputProps: {
                max: maxStartDate,
              },
            }}
            required
            fullWidth
          />
          <TextField
            label={t("END_DATE_TIME")}
            type="datetime-local"
            name="end_time"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            value={endDate}
            onChange={onChange}
            disabled={startDate === ""}
            InputProps={{
              inputProps: {
                max: maxEndDate,
                min: minEndDate,
              },
            }}
            required
            fullWidth
          />
        </div>
        <div className={classes.submitButtons}>
          <IconButton
            type="submit"
            variant="contained"
            color="secondary"
            size="small"
          >
            {submitIcon}
          </IconButton>
          <IconButton
            variant="outlined"
            color="secondary"
            size="small"
            onClick={reset}
          >
            {resetIcon}
          </IconButton>
        </div>
      </form>
    </>
  );
};
